import script from "./powerStationMap.vue?vue&type=script&setup=true&lang=js"
export * from "./powerStationMap.vue?vue&type=script&setup=true&lang=js"

import "./powerStationMap.vue?vue&type=style&index=0&id=8e492b4e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e492b4e"]])

export default __exports__